import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { RegionDeliveryHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/region/region-delivery-hdr-container.model';



@Injectable({
  providedIn: 'root'
})
export class RegionHdrService extends BaseApiTemplateService<RegionDeliveryHeaderContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/delivery-region
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/delivery-region';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/delivery-region';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/delivery-region';
    this.httpClient = http;
  }
}
